<template>
  <div>
    <a-col :span="6">
      <a-card
        class="antd-pro-pages-dashboard-analysis-salesCard"
        :style="{ height: '260px', width: '100%', 'margin-top': '24px' }"
      >
        <div class="cardHead">
          <div class="radiusW">
            <div class="radius"></div>
            <span class="radiusTitleStatis">远传表电池统计</span>
          </div>

          <div class="extra">
            <a-select style="min-width: 120px; width: 100%" v-model="selectData" @change="selectDatasa()">
              <a-select-option value="metering_battery">计量电池电量</a-select-option>
              <a-select-option value="communication_battery">通讯电池电量</a-select-option>
              <a-select-option value="meter_voltage">计量电池电压</a-select-option>
              <a-select-option value="communication_voltage">通讯电池电压</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="content">
          <ClassifiedStatisticsEchart :data="classDataList"></ClassifiedStatisticsEchart>
        </div>
      </a-card>
    </a-col>

    <a-col :span="9">
      <a-card
        class="antd-pro-pages-dashboard-analysis-salesCard"
        :style="{ height: '260px', width: '100%', 'margin-top': '26px' }"
      >
        <div slot="title">
          <div class="radius"></div>
          <div class="radiusTitle">昨日用水量增长前10名监测</div>
        </div>
        <div slot="extra" class="extra">
          <span @click="goExtra">查看所有></span>
        </div>
        <div class="content">
          <BarEchart :data="waterList" />
        </div>
      </a-card>
    </a-col>

    <a-col :span="9">
      <a-card
        class="antd-pro-pages-dashboard-analysis-salesCard"
        :style="{ height: '260px', width: '100%', 'margin-top': '24px' }"
      >
        <div slot="title">
          <div class="radius"></div>
          <div class="radiusTitle">昨日大用户前十名监测</div>
        </div>
        <div class="content">
          <BarEchart :data="userwaterList"></BarEchart>
        </div>
      </a-card>
    </a-col>
  </div>
</template>

<script>
import ClassifiedStatisticsEchart from './module/ClassifiedStatisticsEchart.vue'
import BarEchart from './module/BarEchart.vue'
export default {
  name: 'RemoteZoneLeft',
  components: {
    ClassifiedStatisticsEchart,
    BarEchart,
  },
  data() {
    return {
      classDataList: {},
      userwaterList: {},
      waterList: {},
      selectData: 'metering_battery',
    }
  },
  methods: {
    //远传表电池统计
    selectDatasa() {
      this.$http
        .get('/pipe-network/meter-history/communication', {
          params: {
            type: this.selectData,
          },
        })
        .then((res) => {
          
          let list = res.data
          var xdata = []
          var seriseData = []
          var meterList = []
          for (var j = 0; j < list.length; j++) {
            xdata.push(list[j].section)
            seriseData.push(list[j].num)
            meterList.push(list[j].meterList)
          }
          this.classDataList = {
            xdata: xdata,
            seriseData: seriseData,
            meterList: meterList,
            color: [
              new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFCB54' }, //柱图渐变色
                { offset: 1, color: '#F69445' }, //柱图渐变色
              ]),
            ],
            grid: {
              x: '8%', //左侧与y轴的距离
              y: '15%', //top部与x轴的距离
              x2: '2%', //右侧与y轴的距离
              y2: '30%', //bottom部与x轴的距离
            },
          }
          console.log(this.classDataList,'1234')
        })
        console.log(this.meterList);
    },
    goExtra() {
      this.$router.push('/remote-water/water-Fluctuation/user')
    },
    getList() {
      //远传水表使用状态分类统计

      //贸易结算表总供水量
      this.$http.get('/pipe-network/yc_user_remote_water_meters/data/get_big_water_meter').then((res) => {
        
        let list = res.data
        var xdata = []
        var sdata = []
        list.map((item) => {
          item.yesterdayMeterNumber = parseFloat(item.yesterdayMeterNumber).toFixed(2)
          xdata.push(item.name)
          sdata.push(item.yesterdayMeterNumber)
        })
        this.waterList = {
          xdata: xdata,
          sdata: sdata,
          color: [
            new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#18B0DD' }, //柱图渐变色
              { offset: 1, color: '#2A80E8' }, //柱图渐变色
            ]),
          ],
          grid: {
            x: '8%', //左侧与y轴的距离
            y: '20%', //top部与x轴的距离
            x2: '2%', //右侧与y轴的距离
            y2: '16%', //bottom部与x轴的距离
          },
        }
      })

      //大用户前十名的监测
      this.$http.get('/pipe-network/yc_user_remote_water_meters/data/yesterday/big/consumer').then((res) => {
        
        let list = res.data
        var xdata = []
        var sdata = []
        list.map((item) => {
          // item.time=item.time.substring(5,item.time.length)
          item.yesterdayMeterNumber = parseFloat(item.yesterdayMeterNumber).toFixed(2)
          xdata.push(item.name)
          sdata.push(item.yesterdayMeterNumber)
        })
        this.userwaterList = {
          xdata: xdata,
          sdata: sdata,
          color: [
            new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#A381E6' }, //柱图渐变色
              { offset: 1, color: '#6146C5' }, //柱图渐变色
            ]),
          ],
          grid: {
            x: '8%', //左侧与y轴的距离
            y: '20%', //top部与x轴的距离
            x2: '2%', //右侧与y轴的距离
            y2: '16%', //bottom部与x轴的距离
          },
        }
        console.log(this.userwaterList)
      })
    },
  },
  mounted() {
    this.getList()
    this.selectDatasa()
  },
}
</script>
<style lang="less" scoped>
.extra {
  cursor: pointer;
}
.radius {
  float: left;
  width: 6px;
  height: 21px;
  background: #0265ff;
  border-radius: 3px;
}
.radiusTitle {
  margin-left: 10px;
  float: left;
  width: 100px;
  height: 21px;
  line-height: 21px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}

.radioTitle {
  height: 29px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.56px;
  font-weight: 600;
}
.extra {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #a7afb5;
  letter-spacing: 0.48px;
  text-align: right;
  font-weight: 400;
}
.cardHead {
  height: 48px;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  border-bottom: 1px solid #e8e8e8;
  .radiusW {
    .radius {
      float: left;
      width: 6px;
      height: 21px;
      background: #0265ff;
      border-radius: 3px;
      margin-left: 14px;
    }
    .radiusTitleStatis {
      margin-left: 10px;
      float: left;
      // width: 100px;
      // height: 21px;
      line-height: 21px;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 15px;
      color: #101010;
      letter-spacing: 0.63px;
      font-weight: 600;
    }
  }

  .extra {
    float: right;
    width: 40%;
    min-width: 120px;
  }
}
/deep/ .ant-card-body {
  padding: 0;
}
</style>
